import { Outlet } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import sizeConfigs from '../../utils/sizeConfigs';
import Topbar from '../../components/Topbar/Topbar';
import Sidebar from '../../components/Sidebar/SideBar';
import React, { useEffect } from 'react';
import { colorConfigs } from 'utils/colors';
// import { useScreenSize } from 'utils/helpers';

const MainLayout = () => {
  function isMobileNavigation(): boolean {
    const userAgent = navigator.userAgent;
    const mobileKeywords = [
      'Mobi', // Smartphones em geral
      'Android', // Dispositivos Android
      'iPhone', // iPhones
      'iPad', // iPads
      'Windows Phone', // Windows Phones
    ];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }

  const isResponsive = isMobileNavigation() ? true : window.innerWidth < 769;

  useEffect(() => {
    console.log('tamanho', isResponsive, window.innerWidth, isMobileNavigation());
  }, [isResponsive]);
  return (
    <Box sx={{ display: 'flex', flexDirection: isResponsive ? 'column' : 'row' }}>
      <Box
        component="nav"
        sx={{
          width: isResponsive ? '100%' : sizeConfigs.sidebar.width,
          height: isResponsive ? '80px' : '100%',
          flexShrink: 0,
        }}
      >
        <Sidebar />
      </Box>
      {!isResponsive && <Topbar />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: isResponsive ? 0 : '50px',
          width: isResponsive ? '100%' : `calc(100% - ${sizeConfigs.sidebar.width})`,
          minHeight: '100vh',
          backgroundColor: colorConfigs.mainBg,
        }}
      >
        <Outlet />
        <Typography variant="body2" sx={{ textAlign: 'center', marginTop: 2 }}>
          Versão 1.0.2
        </Typography>
      </Box>
    </Box>
  );
};

export default MainLayout;
